import { RootContainer } from '../../../../core/root_container';
import { VariationsAttrModel } from '../../../models/variations_attr_model';
import { FilterVariationsAttr } from './filter_variations_attr';

export default class FilterVariationsAttrContainer extends RootContainer<VariationsAttrModel> {
  constructor(model: VariationsAttrModel, id: string) {
    super();
    super.mount(FilterVariationsAttr, id);
    this.update(model);
  }

  static init(model?: VariationsAttrModel) {
    return model ? new FilterVariationsAttrContainer(model, model.id) : null;
  }
}
